import type { RefObject } from 'react'

import { useEffect, useState } from 'react'
import { prefersReducedMotion } from '@/lib/gsap'

/**
 * Flips to true once the element has scrolled into view, and stays true.
 */
export const useInView = (ref: RefObject<Element | null>, rootMargin = '0px 0px -15% 0px'): boolean => {
    const [inView, setInView] = useState(false)

    useEffect(() => {
        const element = ref.current

        if (!element) return

        if (prefersReducedMotion() || typeof IntersectionObserver === 'undefined') {
            setInView(true)
            return
        }

        const observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
                setInView(true)
                observer.disconnect()
            }
        }, { rootMargin })

        observer.observe(element)

        return () => observer.disconnect()
    }, [ref, rootMargin])

    return inView
}
